import { useTranslation } from 'react-i18next';
import { cleanWorkingNow, joinNames, sinceLabel, type WorkingNowItem } from './workingNowModel';

/**
 * D-255 - a permanent mark under the ticket's title: "🟢 [שם] עובדת על זה · מ-14:20" while
 * someone's "אני על זה" timer is running; gone when it stops. Several people -> all names.
 * `showTime={false}` is the portal: the display name only.
 */
export default function WorkingNowBanner({ items, showTime = true, testId = 'working-now' }: {
  items: WorkingNowItem[] | null | undefined;
  showTime?: boolean;
  testId?: string;
}) {
  const { t, i18n } = useTranslation();
  const list = cleanWorkingNow(items);
  if (list.length === 0) return null;
  const lang = i18n.language || 'he';
  const names = joinNames(list.map((i) => i.name), lang);
  const since = showTime ? sinceLabel(list, lang) : '';
  return (
    <p
      role="status"
      data-testid={testId}
      className="mt-1.5 inline-flex flex-wrap items-center gap-x-1.5 rounded-full border border-success-200 bg-success-50 px-3 py-1 text-sm text-success-800"
    >
      <span aria-hidden="true">🟢</span>
      <span><bdi>{t('workingNow.text', { count: list.length, names })}</bdi></span>
      {since && <span className="text-success-700">{t('workingNow.since', { time: since })}</span>}
    </p>
  );
}
